import React from "react";
import style from "../../styles/instructionview";

export default (props) => {
  const lastPart = props.url.split("/").pop();
  const id = props.embedId.length > 0 ? props.embedId : lastPart;
  const isWatchVideo = props.url.includes("watch");

  const containerStyle = isWatchVideo
    ? { ...style.vidPlayer, marginLeft: 20 }
    : { ...style.vidPlayer, display: "flex", justifyContent: "center" };

  const iframeStyle = isWatchVideo
    ? { height: 270, width: 480 }
    : { height: 480, width: 270 };

  return (
    <div style={containerStyle}>
      {id && (
        <iframe
          style={iframeStyle}
          src={`https://www.youtube.com/embed/${id}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/YouTubeVideo.js